<script setup lang="ts">
import { EVENT_TYPE } from "~/constants";

export interface ListVideosProps {
  items: IModelEvent[];
  title?: string;
  loading?: boolean;
  hideOnNoContent?: boolean;
  isPlaying?: boolean;
}

const props = withDefaults(defineProps<ListVideosProps>(), {});

const { t } = useI18n();
const route = useRoute();

const badgeTitle = (type: string) => {
  if (type === EVENT_TYPE.USER_CLIP)
    return t("labels.clip", 1);
  else if (type === EVENT_TYPE.USER_HIGHLIGHT)
    return t("labels.highlights", 0);
  else
    return "";
};

const badgeIcon = (type: string) => type === EVENT_TYPE.USER_CLIP ? "clip" : "highlight";
</script>

<template>
  <BaseList
    grid-class="form-column baseVideoCard__list"
    :limit="1"
    :items="props.items"
    :hide-on-no-content="props.hideOnNoContent"
  >
    <template #start>
      <div v-if="props.title" class="flex items-center justify-between p-4">
        <h3 class="text-heading-4 text-secondary">
          {{ props.title }}
        </h3>
      </div>
    </template>

    <template #item="{ item }">
      <BaseButton
        type="icon"
        tag="nuxt-link"
        :to="{ path: route.path, query: { type: item.eventType, mediaId: item.id } }"
        :name="`item-${item.id}`"
        class="w-full"
      >
        <CardVideo
          :title="item.title"
          :badge-title="badgeTitle(item.eventType)"
          :badge-icon="badgeIcon(item.eventType)"
          :image-url="item.imageUrl"
          :is-active="Boolean(item.id === route.query.mediaId)"
          :is-playing="Boolean((item.id === route.query.mediaId) && props.isPlaying)"
        />
      </BaseButton>
    </template>
    <template #skeleton>
      <CardVideoSkeleton />
    </template>
    <template #end>
      <div
        role="separator"
        class="hr mx-4 mt-4"
        style="background: var(--base-background-color)"
      />
    </template>
  </BaseList>
</template>

<style lang="scss">
.baseVideoCard__list {
  @apply px-0;
}
</style>
